import React from 'react';
import { Row, Col, Badge } from 'reactstrap';
import dayjs from 'dayjs';
import StackedBarChart2 from '../Charts/StackedBarChart2.jsx';
import RichScatterPlot from '../Charts/RichScatterPlot.jsx';

class TimePanel extends React.Component {
  constructor(props) {
    super();
    this.state = {
      currentYear: -1,
      currentMonth: 0,
    };
    this.summaryYearInfo = [];
    this.summaryYear = [];
    this.summaryMonthInfo = [];
    this.summaryMonth = [];
    this.monthDataInfo = [];
    this.monthData = [];
  }

  componentWillReceiveProps(nextProps) {
    this.updateSummaryInfo(nextProps, this.state.currentYear, this.state.currentMonth)
  }

  shouldComponentUpdate(nextProps, nextState) {
    if(nextState !== this.state)
      return true;
    if(nextProps.filterTimeStamp !== this.props.filterTimeStamp)
      return true;
    return false
  }

  selectYear = (currentYear => {
    this.updateSummaryInfoMonth(this.props, currentYear, this.state.currentMonth);
    this.setState({currentYear});
  }).bind(this);

  selectMonth = (currentMonth => {
    if(!this.summaryMonth[currentMonth])
      return;
    currentMonth = this.summaryMonth[currentMonth].id - 1;
    this.selectAbsoluteMonth(currentMonth);
  }).bind(this);

  selectAbsoluteMonth = (currentMonth => {
    this.updateSummaryInfoMonthDetail(this.props, this.state.currentYear, currentMonth);
    this.setState({currentMonth});
  }).bind(this);

  selectYearMonth = ((year, month) => {
    this.selectYear(year - this.firstYear);
    this.selectAbsoluteMonth(month);
  }).bind(this);

  updateSummaryInfo(props, currentYear) {
    let {
      listEMMethod,
      dataListEMDs,
    } = props.base;
    let {
      filterResults,
      filterMap,
    } = props.filtered;
    this.summaryYearInfo = [];
    this.summaryMonthInfo = [];
    this.monthData = [];
    this.monthDataInfo = [
        {name: 'date', index: 0, text: 'Release date'},
        {name: 'reso', index: 1, text: 'Resolution'},
        {name: 'grid', index: 2, text: 'Number of grid points'},
    ];
    if(!filterResults || !filterResults.length)
      return;

    let currentMonth = 0;
    this.timeRange = [[dayjs().toDate(), dayjs('1970-01-01').toDate()]]
      .concat(filterResults).reduce((a,b) => [a[0]>dataListEMDs[b].t?dataListEMDs[b].t:a[0], a[1]<dataListEMDs[b].t?dataListEMDs[b].t:a[1]]);
    this.firstYear = this.timeRange[0].getFullYear();
    this.lastYear = this.timeRange[1].getFullYear();
    if(currentYear < 0) {
      // initial update
      let currentDate = dayjs(this.timeRange[1]).subtract(1, 'month');
      currentYear = currentDate.year() - this.firstYear;
      currentMonth = currentDate.month();
    }
    for(let year = this.firstYear; year <= this.lastYear; ++year)
      this.summaryYearInfo.push({name: `${year}`, id: year});
    this.summaryYear = this.summaryYearInfo.map(y => {
      let counterMethod = listEMMethod.map(m => 0);
      filterResults.forEach(i => {
        if(dataListEMDs[i].t.getFullYear() === y.id)
          counterMethod[dataListEMDs[i].m]++;
      });
      return {
        name: y.name,
        id: +y.id,
        values: counterMethod,
      };
    });
    this.state.currentMonth = currentMonth;
    this.updateSummaryInfoMonth(props, currentYear, currentMonth);
  }

  updateSummaryInfoMonth(props, currentYear, currentMonth) {
    let {
      listEMMethod,
      dataListEMDs,
    } = props.base;
    let {
      filterResults,
      filterMap,
    } = props.filtered;
    if(!filterResults || !filterResults.length)
      return;

    if(currentYear < 0) {
      // initial update
      let currentDate = dayjs(this.timeRange[1]).subtract(1, 'month');
      currentYear = currentDate.year() - this.firstYear;
      if(currentMonth < 0)
        currentMonth = currentDate.month();
    }
    this.summaryMonthInfo = [
      {name: 'Jan', id: 1},
      {name: 'Feb', id: 2},
      {name: 'Mar', id: 3},
      {name: 'Apr', id: 4},
      {name: 'May', id: 5},
      {name: 'Jun', id: 6},
      {name: 'Jul', id: 7},
      {name: 'Aug', id: 8},
      {name: 'Sep', id: 9},
      {name: 'Oct', id: 10},
      {name: 'Nov', id: 11},
      {name: 'Dec', id: 12},
    ];
    this.summaryMonth = this.summaryMonthInfo.map(mon => {
      let counterMethod = listEMMethod.map(m => 0);
      filterResults.forEach(i => {
        if(dataListEMDs[i].t.getFullYear() === this.firstYear + currentYear &&
          dataListEMDs[i].t.getMonth() + 1 === mon.id)
          counterMethod[dataListEMDs[i].m]++;
      });
      return {
        name: mon.name,
        id: +mon.id,
        values: counterMethod,
      };
    }).filter(mon => mon.values.reduce((a,b) => a+b) > 0);
    this.updateSummaryInfoMonthDetail(props, currentYear, currentMonth);
  }

  updateSummaryInfoMonthDetail(props, currentYear, currentMonth) {
    let {
      listEMMethod,
      dataListEMDs,
    } = props.base;
    let {
      filterResults,
      filterMap,
    } = props.filtered;
    if(currentYear < 0) {
      // initial update
      let currentDate = dayjs(this.timeRange[1]).subtract(1, 'month');
      currentYear = currentDate.year() - this.firstYear;
      if(currentMonth < 0)
        currentMonth = currentDate.month();
    }
    this.timeRangeDetail = [
      dayjs(new Date(this.firstYear + currentYear, currentMonth, 1)).subtract(1, 'month').toDate(),
      dayjs(new Date(this.firstYear + currentYear, currentMonth, 1)).add(2, 'month').toDate()
    ];
    this.monthData = listEMMethod.map((m, mi) => ({
      name: m.name,
      symbolSize: 1,
      data: dataListEMDs.map((d, di) => (filterMap[di] && d.t >= this.timeRangeDetail[0] && d.m === mi && d.t <= this.timeRangeDetail[1]) ? [d.t, d.r, d.g, d.n, di] : undefined)
        .filter(d => d).sort((a,b) => a[0].getTime()-b[0].getTime()),
    }));
  }

  render() {
    let {compareDataInfo} = this.props.filtered;
    let {sizeFactor} = this.props;
    if(!sizeFactor) sizeFactor = 1;
    return (
      <div>
        <Row>
          <Col xs={6}>
            <Row>
              <Col>
                <StackedBarChart2
                  width={200 * sizeFactor}
                  height={150 * sizeFactor}
                  schema={compareDataInfo}
                  data={this.summaryYear}
                  tooltipSide={1}
                  onSelected={this.selectYear}
                  sizeFactor={sizeFactor}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <StackedBarChart2
                  width={200 * sizeFactor}
                  height={150 * sizeFactor}
                  schema={compareDataInfo}
                  data={this.summaryMonth}
                  tooltipSide={1}
                  onSelected={this.selectMonth}
                  sizeFactor={sizeFactor}
                />
              </Col>
            </Row>
          </Col>
          <Col xs={6}>
            <RichScatterPlot
              width={200 * sizeFactor}
              height={300 * sizeFactor}
              schema={this.monthDataInfo}
              data={this.monthData}
              tooltipSide={1}
              onSelected={this.props.onEMDSelected}
              sizeFactor={sizeFactor}
            />
          </Col>
        </Row>
      </div>
    )
  }
}

export default TimePanel;
